import * as React from 'react';
import { noop } from '../helper';

/**
 * Interface for `CheckboxControlContext`
 */
export interface ICheckboxControlContext {
  values: Array<string | number>;
  onToggle: (value: string | number) => void;
  status: 'error' | 'success' | undefined;
  tooltip: React.ReactNode;
}

/**
 * Low level API to control `CheckboxInput`.
 *
 * Most of the time you would use `<CheckboxControlGroup />` which use this under the hood.
 */
export const CheckboxControlContext = React.createContext<ICheckboxControlContext>({
  onToggle: noop,
  status: undefined,
  tooltip: undefined,
  values: [],
});
